import React from 'react'
import { BrowserSearchField } from 'storfox-query-builder'

import * as API from '~/constants/api'

function CompanySearchField (props) {
  return (
    <BrowserSearchField
      api={API.AUTOMATION_RULE_COMPANY_LIST}
      {...props}
    />
  )
}

export default CompanySearchField
